<template>
  <div class="protocol login-protocol">
    <navigation>万恒权益平台权益服务协议</navigation>
    <section class="content">
      <p class="text version">合同版次：2022（V1.0）</p>
      <p class="text tab-2">本协议是用户与深圳市万恒科技有限公司所有者（以下简称为"万恒科技"）之间就万恒权益平台服务所订立的契约，在用户签订本协议前，用户已经阅读、理解并接受本协议以及平台各类规则，并承诺遵守中国法律规定，如用户不同意，或无法准确理解相关条款的含义，请不要注册使用平台服务。用户一经注册或使用本平台服务即视为对本协议全部条款已充分理解并完全接受。</p>
      <p class="text tab-2">1.定义与解释</p>
      <p class="text tab-2">1.1本协议：指《万恒权益平台权益服务协议》任何条款、明细、信息、补充说明及补充协议。本协议为用户与本公司及本平台之间约定相关权利义务的具有法律约束力的合同文件，并适用于用户注册使用本平台服务的全部活动。</p>
      <p class="text tab-2">1.2万恒权益平台：指深圳市万恒科技有限公司经营管理的，为其用户提供万恒权益平台权益服务的介质。</p>
      <p class="text tab-2">1.3用户：为年满18周岁且具有完全民事行为能力的中华人民共和国公民，以下简称“您”或“用户”。</p>
      <p class="text tab-2">1.4万恒权益平台权益服务：指平台为用户提供的包括但不限于支付转账、消费、娱乐、资讯、交通出行、生活服务等各类服务，兼容自有业务产品、外接第三方业务产品服务。具体优惠服务和使用规则以平台实际展示为准。</p>
      <p class="text tab-2">2.服务内容及申请</p>
      <p class="text tab-2">2.1您申请开通万恒权益平台权益服务的，平台有权提供免费服务，平台也有权向您收取万恒权益平台服务费用，您在平台页面点击“免费领取”按钮，或点击“立即开通”（具体以平台实际展示为准）并支付万恒权益平台费用后，即视为您与平台之间就万恒权益平台权益服务达成一致意见。</p>
      <p class="text tab-2">2.2 您开通万恒权益平台权益服务后，可在平台上享受相关优惠服务，详见附件一，具体优惠服务以平台实际展示或平台提供的相关万恒权益手册为准。</p>
      <p class="text tab-2">2.3当您按照平台页面提示填写信息、阅读并同意本协议且完成首次登陆程序后，即获得万恒权益平台账户并成为万恒权益平台用户。万恒权益平台只允许每位用户使用一个万恒权益平台账户。如有证据证明或万恒权益平台有理由相信您存在不当注册或不当使用多个万恒权益平台账户的情形，万恒权益平台可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给万恒权益平台及相关方造成损失的，您还应承担赔偿责任。</p>
      <p class="text tab-2">2.4您有权使用您确认的手机号码（或称“账户名称”）及手机验证码（账户名称及验证码合称“账户”）登录万恒权益平台，或通过合作方入口免登陆进入到万恒权益平台。</p>
      <p class="text tab-2">2.5由于您的万恒权益平台账户关联您及万恒权益平台的商业信息，您的万恒权益平台账户仅限您本人使用。未经万恒权益平台同意，您直接或间接授权第三方使用您的万恒权益平台账户或获取您账户项下信息的行为无效。如有证据证明或万恒权益平台有理由判断您万恒权益平台账户的使用可能危及您的账户安全及/或万恒权益平台信息安全的，万恒权益平台可拒绝提供相应服务或终止本协议。</p>
      <p class="text tab-2">3.万恒权益平台服务及规范</p>
      <p class="text tab-2">3.1万恒权益平台提供包括但不限于支付转账、消费、娱乐、资讯、交通出行、生活服务、酒店住宿等各类服务，兼容自有业务产品、外接第三方业务产品服务。</p>
      <p class="text tab-2">3.1.1商城服务：合作服务方利用平台向您销售产品或提供服务，您应按照您与合作服务方签订的具体服务协议向合作服务方偿付产品或服务的价款。</p>
      <p class="text tab-2">3.1.2万恒权益平台和或合作服务方提供的单项服务，包括但不限于“资讯”、“视频”、“游戏”、“出行”等。</p>
      <p class="text tab-2">3.1.3万恒权益平台有权根据业务运行规则不时地变更、暂停上述服务或上线其他服务类型，权益调整将在相应服务页面进行通知或公告，您可以通过万恒权益平台查询最新的会员权益内容，具体规则及费用计收以万恒权益平台规则为准。</p>
      <p class="text tab-2">3.2 费用收取 </p>
      <p class="text tab-2">3.2.1 费用收取时间：本平台上不同产品及服务对应不同收费标准，具体收费时点以平台显示为准。</p>
      <p class="text tab-2">3.2.2 费用收取方式：万恒权益平台服务费用采用线上付费的方式，包括但不限于微信、支付宝、银行卡快捷支付及第三方支付等方式。具体付款方式以平台显示为准。</p>
      <p class="text tab-2">3.2.3 退款规则：用户理解并同意，权益服务生效后原则上不可退款。</p>
      <p class="text tab-2">3.3 自动续费</p>
      <p class="text tab-2">3.3.1 自动续费服务是指在会员已开通VIP会员服务的前提下，出于会员对于自动续费的需求，避免会员因疏忽或其他原因导致未能及时续费而推出的服务。如会员选择开通自动续费服务的，即会员授权万恒权益平台可在会员服务期限即将过期时或会员服务的订阅周期即将到期时，委托支付渠道从与您的自有充值账户、绑定的第三方支付账户、银行卡、通信账户等（以下统称“账户”）余额中代扣下一个计费周期的费用。该服务实现的前提是您已开通自动续费及绑定相关账户，且可成功从其上述账户中足额扣款。</p>
      <p class="text tab-2">3.3.2 计费周期：如月度、季度、年度等（具体以万恒权益平台提供的为准），会员可自行选择。</p>
      <p class="text tab-2">3.3.3 自动扣款规则：</p>
      <p class="text tab-2">（1）会员选择开通自动续费的，则视为同意授权万恒权益平台可在会员服务期限即将过期时或过期后，依据支付渠道的扣款规则发出扣款指令，并同意支付渠道可以根据万恒权益平台发出的扣款指令，在不验证会员账户密码、支付密码、短信校验码等信息的情况下从账户中扣划下一个计费周期的费用。</p>
      <p class="text tab-2">（2）除非会员主动明确地取消了自动续费，否则，会员对万恒权益平台的自动扣款委托长期有效、不受次数限制。</p>
      <p class="text tab-2">（3）由于自动续费服务需要您主动操作取消，如果您未主动明确地取消自动续费，则将视为您同意万恒权益平台可依据支付渠道的扣款规则在会员服务期限到期后的一定期限内进行不时的扣款尝试（即使您账户内金额不足）。</p>
      <p class="text tab-2">（4）一旦扣款成功，万恒权益平台将为您开通本次计费周期对应的VIP会员服务；万恒权益平台在此特别提醒您，您所支付的本次计费周期对应的VIP会员服务费用的金额以您在开通自动续费服务时，与万恒权益平台约定的自动续费价格为准：但在平台开展活动或其他万恒权益平台与您另有约定的情形下，前述金额以万恒权益平台与您的相关约定为准。同时，在自动续费服务取消后，再次开通自动续费服务的，您所支付的本次计费周期对应的VIP会员服务费用的金额以再次开通时，与万恒权益平台约定的自动续费价格为准。</p>
      <p class="text tab-2">3.3.4 取消方式：</p>
      <p class="text tab-2">（1）联系万恒权益平台在线人工客服或电话人工客服，提交申请取消自动续费，工作人员将在3~5个工作日内帮您取消自动续费；</p>
      <p class="text tab-2">您知悉并同意，自动续费状态更新可能存在显示延时，具体以万恒权益平台内显示的您的续费状态为准。且您在成功取消前，已经委托万恒权益平台自动续费的扣款指令仍然有效，具体退款规则参考本协议第3.2.3条 约定；</p>
      <p class="text tab-2">3.3关于退款/退货的特别约定：</p>
      <p class="text tab-2">3.3.1由于市场变化及各种以合理商业难以控制的因素的影响，万恒权益平台无法保证您提交的订单信息中希望购买的产品都会有货；如您下单所购买的产品发生缺货，您有权取消订单；合作服务方或本平台亦有权取消订单，并为您（若已付款）办理退款。</p>
      <p class="text tab-2">3.3.2您使用本协议约定的分期服务成功下单后，如发生退款/退货的，退款金额的确定及相关流程以平台规则为准；其他退货相关事宜以合作服务方的商品售后服务政策及相关退货规则为准。</p>
      <p class="text tab-2">3.4服务规则</p>
      <p class="text tab-2">3.4.1如您通过平台向合作服务方购买产品或服务的，则您知晓并同意，合作服务方向您交付产品或服务并承担物流及售后保障，如您需要开具发票的，由合作服务方负责开具；平台仅提供居间服务，并非您所购买的产品或服务的提供方，不对产品或服务承担任何售后保障服务。</p>
      <p class="text tab-2">3.4.2万恒权益平台可通过平台、网站、电子邮件、手机短信等向您发送服务产品、重要提示、促销信息、订单申请信息、服务协议、服务规则等信息。您如果不愿意接收此类信息，您有权通过万恒权益平台提供的相应的退订功能进行退订。</p>
      <p class="text tab-2">3.4.3 万恒权益平台有权在确有必要的情况下，自行或授权平台的其他方通过合理的方式向用户或用户联系人告知本协议相关情况。</p>
      <p class="text tab-2">3.4.4如您对本服务有异议，您可以联系万恒权益平台客服中心并提出异议。</p>
      <p class="text tab-2">4.权利和义务</p>
      <p class="text tab-2">4.1在注册万恒权益平台账号或使用服务的过程中，您有义务提供自己的真实资料，您同意并提交本人手机号码和邮箱等本站需的个人资料，并保证提供的资料真实、准确、完整、合法有效，用户资料如有变动的，应及时更新资料。权益仅限本人使用，为使您更好地使用万恒权益平台的各项服务，保障您的账户安全，万恒权益平台可要求您按照万恒权益平台的规则及我国法律规定完成实名认证。一旦实名认证通过，则用户姓名、身份证、护照等信息不可更改。如果用户提供的资料不合法、不真实、不准确、不详尽，用户需承担因此引起的相应责任及后果，并且万恒权益平台保留终止用户参与该活动的权利。</p>
      <p class="text tab-2">4.2用户应妥善保管用户账户、密码和/或数字证书、身份证信息、手机号码、银行卡信息、住址信息、邮箱信息等个人信息，不得以出租、转借或以其他方式将本协议项下的服务过程中的任何上述信息交由其他任何第三方使用，任何使用用户上述信息申请本协议项下服务的均被平台视为用户操作且不可撤回或撤销。如用户发现有他人冒用、盗用或有其他可能危及到用户账户资金安全情形时，应立即通知平台，向平台申请暂停相关服务。非因平台的过错导致的任何损失由用户自行承担。</p>
      <p class="text tab-2">4.3平台对于您提供的、平台自行收集到的、经认证的个人信息将按照本协议及有关规则予以保护、使用或者披露。平台将采用行业标准惯例以保护您的个人资料。</p>
      <p class="text tab-2">4.4用户应合理使用其享有的万恒权益平台服务，除为实现用户自身的万恒权益平台服务利益外，不得利用其享有的服务非法获利，不得以任何形式售卖其所享有的服务，不得滥用其所享有的服务，如因用户不当行为致平台合理怀疑的或判定的，平台有权暂停或关闭用户万恒权益平台服务，此外，用户需承担因此引起的相应责任及后果。</p>
      <p class="text tab-2">4.5平台有理由认为用户不再或可能不再符合本协议项下服务的开通或使用条件时，平台有权拒绝为用户开通服务或提供本协议项下的各项服务。</p>
      <p class="text tab-2">4.6平台有权在法律法规允许的范围内，结合业务发展等实际情况，调整平台服务范围、各项功能和收费标准及其他重要事项，并通过平台公告等方式及时通知用户。</p>
      <p class="text tab-2">4.7平台对用户提供的相关信息负有保密的义务，并保证将按照法律法规规定保护用户提供的相关信息，经过用户同意授权的除外。</p>
      <p class="text tab-2">5.知识产权</p>
      <p class="text tab-2">5.1用户知悉，万恒权益平台知识产权（包括但不限于商标、专利及著作权等）归平台所有，非经平台事先书面同意，用户不得使用、修改、复制、公开传播、篡改或以其他方式侵犯万恒权益平台知识产权。</p>
      <p class="text tab-2">6.免责条款</p>
      <p class="text tab-2">6.1平台出现下列任一状况而无法正常运作，致使无法向用户提供本协议项下服务，平台不承担任何违约或赔偿责任，该状况包括但不限于：</p>
      <p class="text tab-2">6.1.1在服务平台维护期间；</p>
      <p class="text tab-2">6.1.2电信设备出现故障不能进行数据传输的；</p>
      <p class="text tab-2">6.1.3因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的；</p>
      <p class="text tab-2">6.1.4由于黑客攻击、电信部门和其他平台有信息技术依赖的相关部门、企事业单位技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>
      <p class="text tab-2">6.2因国家相关主管部门颁布、变更的法令、政策导致平台不能提供本协议项下服务的，不视为平台违约，平台与用户可根据相关的法令、政策变更条款内容或提前终止本协议。</p>
      <p class="text tab-2">6.3平台有权根据风险及自身业务运营情况需要中止（终止）向用户提供服务，因此导致用户无法使用服务或服务受到限制的，不视为平台违约。平台拟终止提供服务的，应当至少提前一个月在其主页面醒目位置予以公示并通知。</p>
      <p class="text tab-2">6.4对于任何您自万恒权益平台而获得的非万恒权益平台自身的信息、内容、或者广告宣传等资讯，万恒权益平台不负保证真实、准确和完整性的责任。您须自行甄别真伪和谨慎预防风险，否则，无论何种原因，万恒权益平台不对任何非与本平台直接发生的交易和（或）行为承担任何直接、间接、附带或衍生的损失和责任。</p>
      <p class="text tab-2">6.5您理解并同意，因万恒权益平台根据本协议并依法向第三方提供您的用户信息产生的任何后果和风险应由您自行承担，包括但不限于您的借款申请被拒绝、您无法获得更优惠的交易条件、您的相关信息被他人不法利用等。</p>
      <p class="text tab-2">6.6鉴于目前的技术条件，万恒权益平台不保证您在使用本平台时在操作上不受干扰、不会中断或没有错误；不保证会纠正本平台所有缺陷；亦不保证本平台能满足您的所有要求。此外，万恒权益平台保留不经事先通知为维修、升级或其他目的暂停本平台任何部分的权利。  </p>
      <p class="text tab-2">6.7无论在任何情况下，万恒权益平台对本协议所承担的违约赔偿责任总额不超过向您收取的当次服务费用总额。</p>
      <p class="text tab-2">6.8如您对本协议下所有涉及条款的理解发生争议的，万恒权益平台在法律许可的范围内对本协议享有最终的解释权。</p>

      <p class="text tab-2">7.用户的违约及处理</p>
      <p class="text tab-2">7.1 违约认定  发生如下情形之一的，视为您违约：</p>
      <p class="text tab-2">（一）未按时支付平台服务费用或未按时还款的；</p>
      <p class="text tab-2">（二）使用万恒权益平台服务时违反有关法律法规规定的；</p>
      <p class="text tab-2">（三）或违反本协议或本协议补充协议（即本协议第11.2条）约定的。</p>

      <p class="text tab-2">7.2 违约处理措施</p>
      <p class="text tab-2">【信息处理】 您在万恒权益平台上发布的信息构成违约的，万恒权益平台可根据相应规则立即对相应信息进行删除、屏蔽处理。</p>
      <p class="text tab-2">【行为限制】您发生违约后，万恒权益平台可对您执行账户扣分、限制参加营销活动、中止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的，万恒权益平台可暂停或终止向您提供服务。 </p>
      <p class="text tab-2">【处理结果公示】万恒权益平台可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在万恒权益平台上予以公示。</p>

      <p class="text tab-2">7.3赔偿责任 </p>
      <p class="text tab-2">如您的行为使万恒权益平台及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿万恒权益平台及/或其关联公司上述全部损失。</p>
      <p class="text tab-2">如您的行为使万恒权益平台及/或其关联公司遭受第三人主张权利，万恒权益平台及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。</p>

      <p class="text tab-2">7.4特别约定</p>
      <p class="text tab-2">【关联处理】如您因严重违约导致万恒权益平台终止本协议时，出于维护平台秩序及保护消费者权益的目的，万恒权益平台及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议第10条约定的方式通知您。</p>
      <p class="text tab-2">8.协议变更与解除</p>
      <p class="text tab-2">8.1平台有权因国家法律法规变化及网站运营需要不定期地拟定、修改或终止本协议，并及时以公告的方式通知用户。经修订的条款一经通知，立即自动生效，用户应及时关注不时发布的各项服务规则及本协议的变更。若不同意相关规则及条款修改的，应及时终止与平台的协议。如用户继续使用平台提供的服务的，即视为同意更新后的协议。</p>
      <p class="text tab-2">9.使用法律及争议解决</p>
      <p class="text tab-2">9.1本协议的签订、履行、终止、解释和争议解决受中国法律管辖。</p>
      <p class="text tab-2">9.2因本协议引发的或与本协议有关的争议，由平台与用户协商解决，也可由有关部门调解；协商或调解不成的，由<span class="underline">深圳市南山区</span>有管辖权的人民法院管辖。</p>

      <p class="text tab-2">10. 通知</p>
      <p class="text tab-2">10.1有效联系方式 </p>
      <p class="text tab-2">您在注册成为万恒权益平台用户，并接受万恒权益平台服务时，您应该向万恒权益平台提供真实有效的联系方式（包括您的联系电话等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。</p>
      <p class="text tab-2">您在注册万恒权益平台用户时生成的用于登陆万恒权益平台接收站内信、系统消息的会员账号，也作为您的有效联系方式。</p>
      <p class="text tab-2">万恒权益平台将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</p>
      <p class="text tab-2">10.2 通知的送达 </p>
      <p class="text tab-2">万恒权益平台通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在万恒权益平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</p>
      <p class="text tab-2">对于在万恒权益平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码等联系方式为您在万恒权益平台注册、更新时提供的手机号以及在注册万恒权益平台用户时生成的账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</p>
      <p class="text tab-2">您同意司法机关可采取以上一种或多种送达方式向您送达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</p>
      <p class="text tab-2">如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。 </p>

      <p class="text">11.其他</p>
      <p class="text">11.1如果本协议任意条款规定根据任何法律或法规在任何方面被裁定为无效、不合法或不可强制执行，本协议其余规定不应在任何方面受到影响或损害。平台与用户应通过诚意磋商，争取以法律许可以及双方期望的最大限度内有效的规定取代该等无效、不合法或不可强制执行的规定。</p>
      <p class="text">11.2对本协议作出的任何修改和补充均应为书面形式。平台与用户签署的与本协议有关的修改协议和补充协议应是本协议不可分割的组成部分，并应具有与本协议同等的法律效力。</p>
      <p style="padding-bottom:40px">&nbsp;</p>
      <p class="text">附件一：万恒权益平台权益服务具体包括：</p>
      <p class="text">1.会员权益服务：包括但不限于支付转账、消费、娱乐、资讯、交通出行、生活服务等各类服务，具体以平台实际展示为准。</p>
      <p class="text">2.平台合作方服务优惠：万恒权益平台向会员提供的平台合作方定向专属优惠。具体以平台实际展示为准。</p>
      <p class="text">3.平台提供的其他优惠：平台根据平台发展，为用户提供其他优惠，具体以平台实际展示为准。</p>
      <p class="text">本附件一最新更新于2022年3月</p>
      <p style="padding-bottom:40px">&nbsp;</p>
    </section>
  </div>
</template>

<script>

export default {
  name: 'vipProtocol',
  created () {
    this.$bus.$emit('ready')
  }
}

</script>

<style lang="less">
@import "../../../assets/less/mixin.less";

    .login-protocol {
      background-color: white;

      .content {
        padding: 0 48px;
        .title {
            font-weight: bolder;
            color: #333333;
            font-size: 28px;
            text-indent: 40px;
            line-height: 44px;
            margin-top: 10px;
        }
        .text {
            color: #333333;
            font-size: 28px;
            text-indent: 40px;
            line-height: 44px;
        }
        .text:last-child {
            margin-bottom: 10px;
        }
        .underline {
            text-indent: 40px;
            font-weight: bold;
            text-decoration: underline;
        }
        .underline:last-child {
            margin-bottom: 10px;
        }
        .version {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
        }
      }
    }
</style>
